var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-upload-file',_vm._g({attrs:{"upload-params":_vm.uploadParams,"action":_vm.url}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }